// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"e0122dee","296":"2b47d172","575":"07857787"}[chunkId] + ".chunk.js";
};